import styled from 'styled-components';
import * as breakpoints from '../common/mediaQueries';
import * as colors from '../common/colorConstants';

const backgroundColor = colors.lavenderBlue;
const phoneHeaderFontSize = '2.6rem';
const tabletHeaderFontSize = '3.4rem';
const headerHeight = '9rem';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: ${backgroundColor};
  font-family: 'Arial', sans-serif;
  position: relative;
  height: 100%;
`;

export const HeaderSection = styled.div`
  width: 100%;
  height: ${headerHeight};
  padding: 2rem;
  padding-left: 8rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: ${colors.white};
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    padding-left: 1rem;
    justify-content: center; /* Center the logo */
  }
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  padding: 0 30px;
`;

export const Title = styled.h1`
  font-size: 5rem;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: 0.03em;
  font-family: 'Questrial', sans-serif;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    font-size: ${tabletHeaderFontSize};
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    font-size: ${phoneHeaderFontSize};
  }
`;

export const ImageContainer = styled.div`
  height: 50%;
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 2rem;
  margin-top: 3rem;

  img {
    @media screen and (max-width: ${breakpoints.desktop}) {
      width: 100%;
      object-fit: cover;
      object-position: 20% center;
    }
  }

  @media screen and (max-width: ${breakpoints.maxMobile}) {
    visibility: hidden;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: ${headerHeight};
`;

export const Content = styled.div``;

export const Controls = styled.div`
  height: 8rem;
  width: 100%;
`;
